import { createMultiSelectOptionSetValueFromOptionGuid, FieldsToLookupByMasterAttributeId, friendlyValue } from "global/Application";
import { EControlType } from "components/ControlWrapper";
import { ArrayToLookupByPredicateWithMap } from "../../global/Utility/TSFunctions";
import {
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    INonStandard as FAM_INonStandard
} from "model/FlexibleAttributeModel";
import {  INonStandardPayload } from "global/Reducer/dataSlice";

import { bcbs_groupconfigurationsnapshot } from "../../model/CRM";
import { Memoize } from "../Utility/TSFunctions";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { $att_$non_standard_$bcbs_benefitdefinition_id, $att_$non_standard_$bcbs_doesthisbenefitpayaccoridngtotherelatedbe_id, $att_$non_standard_template_$bcbs_nst_benefitdefinition_id, $att_$non_standard_template_$bcbs_nst_doesthisbenefitpayaccoridngtotherelatedbe_id } from "model/ConfigAttributeConstants";

interface IMapping {

    [key: string]: {
        Id: string;
        Name: string;
    };
}

/**
 * Transformers:
 * Moved from Sprint34Transformer.ts
 * Ongoing Enrollment field updated from optionset -> multiselect
 * https://dev.azure.com/blue-infosys/Group%20Library/_sprints/taskboard/Group%20Library%20Team/Group%20Library/Sprint%2035?workitem=502682
 */
export class Sprint43Transformer extends BaseJsonTransformer {
    config: FAM_IGroupConfigurationConfig;
    json: FAM_IGroupConfigurationData;

    constructor({ config, json }: { config: FAM_IGroupConfigurationConfig, json: FAM_IGroupConfigurationData }) {
        super();
        this.config = config;

        this.json = json;

    }

    
    async before(json: FAM_IGroupConfigurationData): Promise<void> {
        console.debug("[tran] Sprint43Transformer.before")
    }

    async transformGroupConfiguration(json: FAM_IGroupConfigurationData, snapshot: bcbs_groupconfigurationsnapshot): Promise<void> {
        
        // random comment moment

        // cache list of fields upon first call
        const fieldInfosMemoized = Memoize(() => {
            return FieldsToLookupByMasterAttributeId(this.config, json.fields);
        });
        
        // --------------------------------------------------------------------------------------------
        

        // map to array of master attributes, first element in array being the visible one.
        const fieldsByMasterAttrId = fieldInfosMemoized();

        json.nonStandardTemplates?.forEach(nsTemplate => {
            let runFieldUpdate = false;
            nsTemplate.relationships?.forEach(nsRel => {
                nsRel?.sectionRefs?.forEach(sectionRef => {
                    if(sectionRef.nonStandards){
                        runFieldUpdate = true;
                    }
                    if(!sectionRef.nonStandards && (sectionRef as any).nonstandards) {
                        sectionRef.nonStandards = (sectionRef as any).nonstandards 
                        delete (sectionRef as any).nonstandards;
                    }
                })
            })
            
           
            if (!runFieldUpdate) return;
            //read template fields
            //clone the template
            const template = nsTemplate;

            const templateFields = ArrayToLookupByPredicateWithMap(template!.fields, t => t.configRef.id, t => {
                const attribute = this.config.cache.map_bcbs_config_attribute[t.configRef.id];
                const masterAttribute = this.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                const controlType = masterAttribute.bcbs_attributetypecode as EControlType;
                return {
                    field: t,
                    attribute,
                    masterAttribute,
                    controlType,
                }
            });
            const templateDefinition = templateFields[$att_$non_standard_template_$bcbs_nst_benefitdefinition_id];
            const templatePayAccordingToBenefit = templateFields[$att_$non_standard_template_$bcbs_nst_doesthisbenefitpayaccoridngtotherelatedbe_id];
            let templateDefinitionValue = "";
            let templatePayAccordingToBenefitValue = "";

            if (templateDefinition.field.values[0].value !== null) {
                templateDefinitionValue = friendlyValue(templateDefinition.controlType, templateDefinition.field.values[0].value);
            }
            if (templatePayAccordingToBenefit.field.values[0].value !== null) {
                templatePayAccordingToBenefitValue = friendlyValue(templatePayAccordingToBenefit.controlType, templatePayAccordingToBenefit.field.values[0].value);
            }

            let nonStandardPayloads: INonStandardPayload[] = []
            //go through each connected NS and update the fields on that.
            template?.relationships?.forEach(rel => {
                let categoryId = rel.categoryID;
                rel.sectionRefs?.forEach(sectionRef => {
                    sectionRef.nonStandards?.forEach(nonStandardRef => {
                        //find the benefits for the category id
                        let benefit = json.benefits.find(ben => ben.id === categoryId);
                        if (benefit) {
                            //do a find on the non standard
                            let benefitNonStandard = benefit.nonStandards.find(ns => ns.id === nonStandardRef.id);

                            //if we find the non standard, update the fields
                            if (benefitNonStandard && benefitNonStandard.deactivated !== true) {
                                //update fields
                                const updatedNonStandard: FAM_INonStandard = benefitNonStandard//structuredClone(benefitNonStandard);
                                //console.log("pre update ns:", updatedNonStandard);
                                updatedNonStandard.name = template.name;
                                updatedNonStandard.partOfTemplate = true;
                                let nonStandardBenefitDefintion = updatedNonStandard.fields.find(field => field.configRef.id === $att_$non_standard_$bcbs_benefitdefinition_id);
                                let nonStandardPayAccordingToBenefit = updatedNonStandard.fields.find(field => field.configRef.id === $att_$non_standard_$bcbs_doesthisbenefitpayaccoridngtotherelatedbe_id);

                                const benefitDefinitionValue = templateDefinition.field.values[0].value; //template value
                                nonStandardBenefitDefintion!.values[0].value = benefitDefinitionValue//structuredClone(benefitDefinitionValue); //ns value
                                //const payAccordingToBenefitValue = templatePayAccordingToBenefit.field.values[0].value; //template value
                                //nonStandardPayAccordingToBenefit!.values[0].value = structuredClone(payAccordingToBenefitValue); //ns value

                                if (nonStandardPayAccordingToBenefit) {
                                    const payAccordingToBenefitValue = templatePayAccordingToBenefit.field.values[0].value; //template value
                                    nonStandardPayAccordingToBenefit!.values[0].value = payAccordingToBenefitValue//structuredClone(payAccordingToBenefitValue); //ns value
                                }
                                //console.log("post update ns:", updatedNonStandard);
                                // const nonStandardPayload: INonStandardPayload = {
                                //     config: this.config,
                                //     nonStandards: [updatedNonStandard],
                                //     benefit: benefit,
                                //     //groupConfiguration: props.groupConfiguration,
                                //     changeTracker: {}
                                // }
                                // nonStandardPayloads.push(nonStandardPayload)
                                // dispatch(addUpdateNonStandards([{
                                //     config: props.state.data.config,
                                //     nonStandards: [updatedNonStandard],
                                //     benefit: benefit,
                                //     //groupConfiguration: props.groupConfiguration,
                                //     changeTracker: {}
                                // }]));
                            }
                        } else if (json.id === categoryId) {
                            //if no benefits look at the GC
                            let gcNonStandard = json.nonStandards.find(ns => ns.id === nonStandardRef.id);
                            if (gcNonStandard && gcNonStandard.deactivated !== true) {
                                //update fields
                                const updatedNonStandard: FAM_INonStandard = gcNonStandard//structuredClone(gcNonStandard);
                                //console.log("pre update ns:", updatedNonStandard);
                                updatedNonStandard.name = template.name;
                                updatedNonStandard.partOfTemplate = true;

                                let nonStandardBenefitDefintion = updatedNonStandard.fields.find(field => field.configRef.id === $att_$non_standard_$bcbs_benefitdefinition_id);
                                let nonStandardPayAccordingToBenefit = updatedNonStandard.fields.find(field => field.configRef.id === $att_$non_standard_$bcbs_doesthisbenefitpayaccoridngtotherelatedbe_id);

                                const benefitDefinitionValue = templateDefinition.field.values[0].value; //template value
                                nonStandardBenefitDefintion!.values[0].value = benefitDefinitionValue//structuredClone(benefitDefinitionValue); //ns value
                                //const payAccordingToBenefitValue = templatePayAccordingToBenefit.field.values[0].value; //template value
                                //nonStandardPayAccordingToBenefit!.values[0].value = structuredClone(payAccordingToBenefitValue); //ns value

                                if (nonStandardPayAccordingToBenefit) {
                                    const payAccordingToBenefitValue = templatePayAccordingToBenefit.field.values[0].value; //template value
                                    nonStandardPayAccordingToBenefit!.values[0].value = payAccordingToBenefitValue//structuredClone(payAccordingToBenefitValue); //ns value
                                }

                                //console.log("post update ns:", updatedNonStandard);
                                // const nonStandardPayload: INonStandardPayload = {
                                //     config: this.config,
                                //     nonStandards: [updatedNonStandard],
                                //     benefit: benefit,
                                //     //groupConfiguration: props.groupConfiguration,
                                //     changeTracker: {}
                                // }
                                // nonStandardPayloads.push(nonStandardPayload)
                                // dispatch(addUpdateNonStandards([{
                                //     config: props.state.data.config,
                                //     nonStandards: [updatedNonStandard],
                                //     benefit: benefit,
                                //     //groupConfiguration: props.groupConfiguration,
                                //     changeTracker: {}
                                // }]));
                            }
                        }
                    })
                })
            });
        })
    }

    
    


    async after(json: FAM_IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint43Transformer.after")

        if (!json.transformers)
            json.transformers = {};

        json.transformers.Sprint43 = true

    }
}
